import { IconProps } from '../../types/IconProps';

export const ArrowRight = ({ variant, className }: IconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    fill='none'
    className={`${className || ''}`}>
    <path
      fill={variant === 'light' ? '#fff' : '#0B223E'}
      d='M21.582 12.45 14.6 19.431a.776.776 0 1 1-1.098-1.098l5.659-5.658H3.965a.776.776 0 0 1 0-1.551h15.196l-5.659-5.658A.776.776 0 1 1 14.6 4.37l6.982 6.983a.776.776 0 0 1 0 1.098Z'
    />
  </svg>
);
